import React, { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import { Modal } from 'react-bootstrap';

const InstructionModal = ({ isOpen, onClose, cartItem, onSaveInstruction }) => {
  const [comment, setComment] = useState("");

  useEffect(() => {
    if (isOpen && cartItem) {
      setComment(cartItem.comments || "");
    }
  }, [isOpen, cartItem]);

  if (!cartItem) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSaveInstruction(cartItem, comment);
    onClose();
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered dialogClassName="instruction-modal-dialog" contentClassName="rounded-4 border-0 shadow-lg" backdrop="static">
      <div className="modal-header border-bottom-0 pb-0 d-flex justify-content-between align-items-center">
        <h5 className="modal-title font-weight-md text-dark mb-0">Special Instructions</h5>
        <button type="button" className="btn text-muted p-0 border-0 bg-transparent" onClick={onClose}>
          <FaTimes size={20} />
        </button>
      </div>
      <div className="modal-body">
        <p className="text-muted mb-3">Add any special requests for <strong className="text-dark">{cartItem.name}</strong></p>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <textarea
              className="dm-instruction-textarea shadow-sm mb-3"
              rows="3"
              placeholder="Type here..."
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              autoFocus
            ></textarea>
          </div>
          <div className="d-flex gap-2">
            <button type="button" className="btn btn-light rounded-pill flex-grow-1 font-weight-bold" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn text-white rounded-pill flex-grow-1 font-weight-bold" style={{ backgroundColor: '#0f172a' }}>
              Save
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default React.memo(InstructionModal);
